var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmLwddoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.636,
    height: 14,
    viewBox: "0 0 11.636 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-add",
    transform: "translate(-36 -11.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M41,25H37V13h4v3a1,1,0,0,0,1,1h3v2h1V16a.455.455,0,0,0-.15-.35l-3.5-3.5A.454.454,0,0,0,42,12H37a1,1,0,0,0-1,1V25a1,1,0,0,0,1,1h4Zm1-11.8L44.8,16H42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(35 -3.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M6,26.212l.885-.885,1.77,1.77,3.1-3.1.885.885L8.654,28.866Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmLwddoj);
export default __webpack_public_path__ + "static/media/Confirm LWD & DOJ.c654d45f24be6213704201f4838343cd.svg";
export { ForwardRef as ReactComponent };